import { render, staticRenderFns } from "./LeadInfo.vue?vue&type=template&id=32314aa5&scoped=true"
import script from "./LeadInfo.vue?vue&type=script&lang=js"
export * from "./LeadInfo.vue?vue&type=script&lang=js"
import style0 from "./LeadInfo.vue?vue&type=style&index=0&id=32314aa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32314aa5",
  null
  
)

export default component.exports